import React, { memo, useState } from "react";
import { cn } from "utils";
import LineHeaderEnd from "../Chat/Charts/LineHeaderEnd";
import ChartFooter from "../Chat/Charts/ChartFooter";
import Empty from "../Chat/Charts/Empty";
import { ChatCategoryCardType } from "../Chat/Cards/type";
import StockDetailLine, { IntervalType } from "./StockDetailLine";

const StockDataType: Record<string, IntervalType> = {
  "1D": "1d",
  "5D": "5d",
  "30D": "30d",
};

const options = [
  { label: "1D", value: StockDataType["1D"] },
  { label: "5D", value: StockDataType["5D"] },
  { label: "30D", value: StockDataType["30D"] },
];

interface ChartLineProps {
  className?: string;
  symbol?: string;
  short_name?: string;
}
/** 组件内部没有对数据做任何格式化，需要外部处理 */
const ChartLine: React.FC<ChartLineProps> = ({
  className = "",
  symbol,
  short_name,
}) => {
  const [dataType, setSelectedDataType] = useState<IntervalType>(
    StockDataType["1D"],
  );
  const currentSymbol = symbol;

  const cardItem = {
    type: "token",
    // properties: { token_symbol: currentSymbol },
    // TODO. 调整真实Symbol数据
    properties: { token_symbol: symbol },
  } as ChatCategoryCardType;

  if (!cardItem) {
    return <Empty />;
  }

  return (
    <div className={cn("w-full", className)}>
      <LineHeaderEnd
        cardItem={cardItem}
        setSelectedDataType={setSelectedDataType as any}
        className="flex flex-row items-center justify-between mb-3"
        options={options}
        defaultValue={StockDataType["1D"]}
        isStock={true}
      />
      <div data-horizontal-scroll="true">
        <StockDetailLine
          dataType={dataType}
          symbol={currentSymbol}
          short_name={short_name}
        />
      </div>
      <ChartFooter showDataSource={false} />
    </div>
  );
};

export default memo(ChartLine, (prev, next) => {
  return prev.symbol === next.symbol;
});
